import * as s from "./GoogleMapStyled";
import MapControl from "./sub/control/MapControl";
import SubHeader from "./sub/subheader";
import RecorderListView from "./sub/leftAside/RecorderListView";
import { GoogleMap } from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import { MapFilterKeyword } from "redux/reducers/map/mapFilter";
import {
  MapSearchData,
  KeywordSearchRecorder,
} from "api/interfaces/dashboardInterface.interface";
import RecorderDetailView from "./sub/leftAside/detail/RecorderDetailView";
import { More } from "./sub/subheader/SubHeader";
import { AlertViewInfo } from "api/interfaces/alertInterface.interface";
import FloatList from "./sub/float";
import MissingList from "./sub/missingList";
import { mapOptions } from "./GoogleMapConfig";
import { useNoticeHeight } from "components/NoticePovider";

type Props = {
  isCollapsed: boolean;
  isRoadview: boolean;
  isViewRecorderList: boolean;

  onChangeCollapsed: () => void;
  onZoomPlus: () => void;
  onZoomOut: () => void;
  onZoomFit: () => void;
  onChangeView: () => void;
  onClickRecorder: (id: string) => void;
  onSearch: (e: MapFilterKeyword) => void;
  onResetSearchInput: () => void;
  // onClickSearchResult?: (latitude: number, longitude: number) => void;

  onCloseRecorderList: () => void;
  onSelectRecorder: (rec: MapSearchData) => void;
  onClickRecorderKeyword: (rec: KeywordSearchRecorder) => void;

  // selectedRecorder: MapSearchData | null;
  more: More;
  onSelectMoreFilter: (e: any) => void;
  onDeleteMoreFilter: (name: string) => void;
  selectedAlert: AlertViewInfo | null;
  onCloseRecorderView: () => void;

  isFetching: boolean;
  initMap: (map: google.maps.Map) => void;
  onHoverSystem: (rec: MapSearchData | null) => void;
  onChangeClusterRadius: (value: number) => void;
  clusterRadius: number;
  cloudStatus: boolean;
  mapZoom: number | undefined;
};

const variants = {
  open: { opacity: 1, right: "15px" },
  closed: { opacity: 1, right: "-383px" },
};

export function GoogleMapPresenter(props: Props): JSX.Element {
  const { noticeHeight } = useNoticeHeight();
  const innerRef = useRef<HTMLDivElement>(null);
  const [innerSize, setInnerSize] = useState<{ [key: string]: number }>({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0]) {
        const { width, height } = entries[0].contentRect;
        setInnerSize({ width, height });
      }
    });

    if (innerRef.current) {
      resizeObserver.observe(innerRef.current);
    }

    // 컴포넌트가 언마운트될 때 observer 해제
    return () => {
      if (innerRef.current) {
        resizeObserver.unobserve(innerRef.current);
      }
    };
  }, [window, innerRef]);

  return (
    <s.Container noticeHeight={noticeHeight}>
      <SubHeader
        isCollapsed={props.isCollapsed}
        // onChangeStatus={props.onChangeStatus}
        onChangeCollapsed={props.onChangeCollapsed}
        onSearch={props.onSearch}
        onResetSearchInput={props.onResetSearchInput}
        // onClickSearchResult={props.onClickSearchResult}
        more={props.more}
        onSelectMoreFilter={props.onSelectMoreFilter}
        onDeleteMoreFilter={props.onDeleteMoreFilter}
        onClickRecorder={props.onClickRecorder}
        onClickRecorderKeyword={props.onClickRecorderKeyword}
      />
      <s.MapInner ref={innerRef}>
        <div className="left-wrapper">
          {props.isViewRecorderList && (
            <RecorderListView
              onClickRecorder={props.onClickRecorder}
              onSelectRecorder={props.onSelectRecorder}
              onClose={props.onCloseRecorderList}
              selectedAlertId={props.selectedAlert?.recorderId}
              isFetching={props.isFetching}
              onHoverSystem={props.onHoverSystem}
            />
          )}
          {props.selectedAlert !== null && (
            <RecorderDetailView
              // recorder={props.selectedRecorder}
              selectedAlert={props.selectedAlert}
              isViewRecorderList={props.isViewRecorderList}
              onModal={props.onCloseRecorderView}
              cloudStatus={props.cloudStatus}
            />
          )}
        </div>
        <s.WidgetWrapper>
          <MissingList />
          <s.ControlContainer>
            <MapControl
              isRoadView={props.isRoadview}
              onZoomPlus={props.onZoomPlus}
              onZoomOut={props.onZoomOut}
              onZoomFit={props.onZoomFit}
              onChangeView={props.onChangeView}
              onChangeClusterRadius={props.onChangeClusterRadius}
              clusterRadius={props.clusterRadius}
              mapZoom={props.mapZoom}
            />
          </s.ControlContainer>
          <s.WidgetContainer
            animate={props.isCollapsed ? "open" : "closed"}
            variants={variants}
            id="widget"
          >
            <FloatList
              onClickRecorder={props.onClickRecorder}
              onSelectRecorder={props.onSelectRecorder}
              innerSize={innerSize}
              isViewRecorderList={props.isViewRecorderList}
              selectedAlert={props.selectedAlert}
              onHoverSystem={props.onHoverSystem}
              cloudStatus={props.cloudStatus}
            />
          </s.WidgetContainer>
        </s.WidgetWrapper>
      </s.MapInner>

      <GoogleMap
        mapContainerStyle={{
          width: "100%",
          height: "100%",
        }}
        options={mapOptions}
        onLoad={(map) => {
          props.initMap(map);
        }}
      />
    </s.Container>
  );
}
